import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  return <section className="py-24 px-6 bg-forest text-cream relative overflow-hidden" data-id="element-101">
      {/* Decorative background circles */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-102">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white opacity-5 rounded-full blur-3xl" data-id="element-103"></div>
        <div className="absolute bottom-10 -left-20 w-72 h-72 bg-terracotta opacity-20 rounded-full blur-3xl" data-id="element-104"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-105">
        <div className="text-center mb-16" data-id="element-106">
          <motion.span initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-terracotta font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-107">
            La Solución Definitiva
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold mb-6" data-id="element-108">
            Presentamos el Método Freezer-Fit
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl md:text-2xl max-w-3xl mx-auto text-sage" data-id="element-109">
            Es un sistema de "Batch Cooking de Bodegón". No es un curso de alta
            cocina, es un manual de supervivencia para madres reales.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="bg-white text-forest rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-110">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-center mb-10" data-id="element-111">
            Aprendés el <span className="text-terracotta" data-id="element-112">Sistema 3-2-1</span>
          </h3>

          <div className="grid md:grid-cols-3 gap-8 mb-10" data-id="element-113">
            <div className="flex flex-col items-center text-center" data-id="element-114">
              <div className="w-20 h-20 rounded-full bg-sage flex items-center justify-center text-4xl font-serif font-bold text-forest mb-4 border-4 border-white shadow-md" data-id="element-115">
                3
              </div>
              <h4 className="font-bold text-xl mb-2" data-id="element-116">Proteínas Base</h4>
              <p className="text-brown text-sm" data-id="element-117">
                Carnes, pollo o legumbres preparadas de forma versátil.
              </p>
            </div>

            <div className="flex flex-col items-center text-center relative" data-id="element-118">
              <div className="hidden md:block absolute top-10 -left-12 text-3xl text-terracotta font-bold" data-id="element-119">
                +
              </div>
              <div className="w-20 h-20 rounded-full bg-sage flex items-center justify-center text-4xl font-serif font-bold text-forest mb-4 border-4 border-white shadow-md" data-id="element-120">
                2
              </div>
              <h4 className="font-bold text-xl mb-2" data-id="element-121">Guarniciones</h4>
              <p className="text-brown text-sm" data-id="element-122">
                Acompañamientos rendidores que no pierden textura al congelar.
              </p>
              <div className="hidden md:block absolute top-10 -right-12 text-3xl text-terracotta font-bold" data-id="element-123">
                +
              </div>
            </div>

            <div className="flex flex-col items-center text-center" data-id="element-124">
              <div className="w-20 h-20 rounded-full bg-terracotta flex items-center justify-center text-4xl font-serif font-bold text-white mb-4 border-4 border-white shadow-md" data-id="element-125">
                1
              </div>
              <h4 className="font-bold text-xl mb-2" data-id="element-126">Salsa Mágica</h4>
              <p className="text-brown text-sm" data-id="element-127">
                El secreto para que todo tenga sabor a recién hecho.
              </p>
            </div>
          </div>

          <div className="bg-sage rounded-xl p-6 text-center border-2 border-dashed border-forest/20" data-id="element-128">
            <p className="text-xl font-bold text-forest" data-id="element-129">
              = 10 viandas diferentes cocinando solo el domingo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}